module.exports = __webpack_public_path__ + "static/media/clone_blue.0e6266c0.svg";